// The automatic Save All commit message (spec/dashboard.md section 4.3: "the commit message is the user's … or" a summary of
// what is staged): the drafts grouped by template (documents) or by kind, two labels per group then "+N", new / deleted
// marked, groups joined with "; ", capped at about 120 characters.
import type { Draft, EntityKind, Workspace } from './Workspace';

const KIND_GROUP: Record<Exclude<EntityKind, 'document'>, string> = {
  string: 'Localization',
  product: 'Products',
  'player-key': 'Player keys',
  'template-selected': 'Template defaults',
  asset: 'Assets',
  'localization-settings': 'Localization settings',
  environment: 'Environment',
  'platform-config': 'Platforms',
};

export const SUMMARY_MAX = 120;
const PER_GROUP = 2;

function groupOf(d: Draft, templates?: Map<string, { displayName?: string | null }>): string {
  if (d.kind !== 'document') return KIND_GROUP[d.kind] ?? d.kind;
  const template = d.template ?? 'Documents';
  const display = templates?.get(template)?.displayName;
  if (display) return display;
  const dot = template.lastIndexOf('.');
  return dot >= 0 ? template.slice(dot + 1) : template;
}

function entry(d: Draft): string {
  return d.status === 'new' ? `${d.label} (new)` : d.status === 'deleted' ? `${d.label} (deleted)` : d.label;
}

export function summarizeDrafts(workspace: Workspace, templates?: Map<string, { displayName?: string | null }>): string {
  const drafts = workspace.all.slice().sort((a, b) => a.createdAt - b.createdAt);
  const groups = new Map<string, Draft[]>();
  for (const d of drafts) {
    const g = groupOf(d, templates);
    const list = groups.get(g) ?? [];
    list.push(d);
    groups.set(g, list);
  }
  const parts = Array.from(groups.entries()).map(([group, list]) => {
    const shown = list.slice(0, PER_GROUP).map(entry).join(', ');
    const more = list.length > PER_GROUP ? ` +${list.length - PER_GROUP}` : '';
    return `${group}: ${shown}${more}`;
  });
  const text = parts.join('; ');
  return text.length > SUMMARY_MAX ? `${text.slice(0, SUMMARY_MAX - 1).trimEnd()}…` : text;
}
